import React from "react";
//Header function defined here
export default function Header() {
  return <div className="header"  > &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AYUSH BOT</div>;
}
